export default __webpack_public_path__ + "static/media/contest_background.22a39e4b.png";